export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[800],
          borderRadius: '2px',
          fontSize: '10px',
          fontWeight: 300,
        },
        arrow: {
          color: theme.palette.grey[800],
        },
      },
    },
  };
}
